import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import loader from "../../assets/Images/loader.gif";
import { toast } from "react-toastify";

const optionAccountTurnover = [
  { label: "Select Option", value: "0" },
  { label: "Diamond(>250Cr)", value: "111260000" },
  { label: "Emerald (100Cr-250Cr)", value: "111260001" },
  { label: "Ruby (10Cr-100Cr)", value: "111260002" },
  { label: "Bronze (1Cr-10Cr)", value: "111260003" },
];

const optionUsingFirewall = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "True" },
  { label: "No", value: "False" },
];

const optionFirewallBusinessModel = [
  { label: "Select Option", value: "" },
  { label: "DIY", value: "0" },
  { label: "Managed Platform", value: "1" },
];

const optionUsingWifi = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "True" },
  { label: "No", value: "False" },
];

const optionWifiBusinessModel = [
  { label: "Select Option", value: "" },
  { label: "DIY", value: "0" },
  { label: "Managed Platform", value: "1" },
];

const optionSecurityAuth = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "True" },
  { label: "No", value: "False" },
];

const optionUsingSDWAN = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "True" },
  { label: "No", value: "False" },
];

const optionSdwanBusinessModel = [
  { label: "Select Option", value: "" },
  { label: "Hub Spoke", value: "0" },
  { label: "Full Mesh", value: "1" },
];
const optionSecurityCamera = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "True" },
  { label: "No", value: "False" },
];
const optionAnalyticsSupport = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "True" },
  { label: "No", value: "False" },
];

const optionPriSip = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "True" },
  { label: "No", value: "False" },
];

const CustomerInfraForm = () => {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // Remove box shadow
      boxShadow: "none",
      backgroundColor: "transparent",
      color: "black",
    }),
  };

  const [loading, setLoading] = useState(false);
  const [activeForm, setActiveForm] = useState("form1");
  const [custmerInfo, setCustomerInfo] = useState("");
  const [selectIndustryType, setSelectIndustryType] = useState("");
  const [industryTypes, setIndustryTypes] = useState([]);
  const [selectAccountTurnover, setSelectAccountTurnover] = useState(
    optionAccountTurnover[0]
  );
  const [selectUsingFirewall, setSelectUsingFirewall] = useState(
    optionUsingFirewall[0]
  );
  const [selectFirewallBusinessModel, setSelectFirewallBusinessModel] =
    useState(optionFirewallBusinessModel[0]);
  const [selectUsingWifi, setSelectUsingWifi] = useState(optionUsingWifi[0]);
  const [selectWifiBusinessModel, setSelectWifiBusinessModel] = useState(
    optionWifiBusinessModel[0]
  );
  const [selectSecurityAuth, setSelectSecurityAuth] = useState(
    optionSecurityAuth[0]
  );
  const [selectUsingSDWAN, setSelectUsingSDWAN] = useState(optionUsingSDWAN[0]);
  const [selectSdwanBusinessModel, setSelectSdwanBusinessModel] = useState(
    optionSdwanBusinessModel[0]
  );
  const [selectSecurityCamera, setSelectSecurityCamera] = useState(
    optionSecurityCamera[0]
  );

  const [selectAnalyticsSupport, setSelectAnalyticsSupport] = useState(
    optionAnalyticsSupport[0]
  );
  const [selectPriSip, setSelectPriSip] = useState(optionPriSip[0]);
  const [userData, setUserData] = useState({
    noOfLocation: "",
    serviceIdLoc: "",
    locationName: "",
    ispNamePri: "",
    ispNameSec: "",
    bandwidthPri: "",
    bandwidthSec: "",
    productFromPri: "",
    productFromSec: "",
    firewallModel: "",
    FirewallExpiryDate: "",
    wifiModel: "",
    sdwanModel: "",
    companySecurityCamera: "",
    numOfAp: "",
    priSipOperator: "",
    numOfChannel: "",
    kdmName: "",
    kdmDepartment: "",
    kdmDesignation: "",
    kdmNumber: "",
    kdmEmail: "",
  });

  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const formatDateString = (dateString) => {
    if (!dateString) {
        return ''; // or any default value you prefer
    }

    const [day, month, year] = dateString.split("-");
    // Assuming dateString is in the format DD-MM-YYYY
    return `${year}-${month}-${day}`;
};

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Industry API call
        const industryTypeApiUrl = process.env.REACT_APP_API_URL;
        const industryTypeRequestBody = {
          Action: "getindustrytype",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          areaCode: "",
          areaName: "",
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };
        const industryTypeResponse = await fetch(industryTypeApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(industryTypeRequestBody),
        });
        const industryTypeData = await industryTypeResponse.json();
        // setIndustryTypes(industryTypeData.Response);
        // console.log("industryTypeData :",industryTypeData.Response)
        if (industryTypeData.Response) {
          const transformedOptions = industryTypeData.Response.map(
            (option) => ({
              label: option.IndTypeName,
              value: option.IndTypeId,
            })
          );
          setIndustryTypes(transformedOptions);
          // console.log("transformedOptions",transformedOptions)
        } else {
          setIndustryTypes([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchCutomerInfraDetail = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getInfoCustomerInfra",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          SearchValue: sessionStorage.getItem("canId"),
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const result = await response.json();
        // console.log(result.Response.Data);
        setCustomerInfo(result.Response.Data[0]);
      } catch (error) {
        console.error("Error fetching ETR reasons:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCutomerInfraDetail();
  }, []);

  useEffect(() => {
    const fetchCutomerInfraDetail = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getCustomerInfraDetails",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          CanId: sessionStorage.getItem("canId"),
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const result = await response.json();
        // console.log("getCustomerInfraDetails :", result.Response.Data);
        // console.log("ExpiryDate",result.Response.Data[0].NetworkSecurity.IfFirewallUsingYesExpiryDate);
        // setSelectIndustryType(result.Response.Data[0].BusinessDetails.IndustryType);
        setUserData({
          noOfLocation: result.Response.Data[0].BusinessDetails.NumberofLocation,
          serviceIdLoc: result.Response.Data[0].BusinessDetails.EmployeeCountatCANIDLocation,
          locationName: result.Response.Data[0].BusinessDetails.HOLocationName,
          ispNamePri: result.Response.Data[0].ConnectivityDetails.ISPNamePrimary,
          ispNameSec: result.Response.Data[0].ConnectivityDetails.ISPNameSecondary,
          bandwidthPri: result.Response.Data[0].ConnectivityDetails.ISPBandwidthPrimary,
          bandwidthSec: result.Response.Data[0].ConnectivityDetails.ISPBandwidthSecondary,
          productFromPri: result.Response.Data[0].ConnectivityDetails.ProductUsingfromPrimaryISP,
          productFromSec: result.Response.Data[0].ConnectivityDetails.ProductUsingfromSecondaryISP,
          firewallModel: result.Response.Data[0].NetworkSecurity.IfYESwhoseFirewallaretheyusing,
          FirewallExpiryDate: formatDateString(result.Response.Data[0].NetworkSecurity.IfFirewallUsingYesExpiryDate),
          wifiModel: result.Response.Data[0].ManagedWIFI.IfYESwhoseWiFiaretheyusing,
          sdwanModel: result.Response.Data[0].SDWANMPLS.IfYESwhoseSDWANMPLSaretheyusing,
          companySecurityCamera:  result.Response.Data[0].VideoAnalytics.CompanyNameSecurityCamera,
          numOfAp: result.Response.Data[0].ManagedWIFI.NumberofAPifUsingYes,
          priSipOperator: result.Response.Data[0].PRISIP.PRISIPOperatorName,
          numOfChannel:  result.Response.Data[0].PRISIP.NumberofChannel,
          kdmName: result.Response.Data[0].KdmDetails.KDMName,
          kdmDepartment: result.Response.Data[0].KdmDetails.KDMDepartment,
          kdmDesignation: result.Response.Data[0].KdmDetails.KDMDesignation,
          kdmNumber: result.Response.Data[0].KdmDetails.KDMContactNumber,
          kdmEmail: result.Response.Data[0].KdmDetails.KDMEmail,
        });
        setSelectIndustryType({
          value: result.Response.Data[0].BusinessDetails.IndustryTypeId,
          label: result.Response.Data[0].BusinessDetails.IndustryType,
        });
        setSelectAccountTurnover({
          value: result.Response.Data[0].BusinessDetails.AccTurnovervalue,
          label: result.Response.Data[0].BusinessDetails.AccTurnover,
        });
        const filterUsingFirewall = optionUsingFirewall.find(
          (item) =>
            item.value ===
            String(result.Response.Data[0].NetworkSecurity.UsingFirewall)
        ).label;
        setSelectUsingFirewall({
          value: result.Response.Data[0].NetworkSecurity.UsingFirewall,
          label: filterUsingFirewall,
        });
        
        setSelectFirewallBusinessModel({
          value: result.Response.Data[0].NetworkSecurity.FirewallBusinessModalValue,
          label: result.Response.Data[0].NetworkSecurity.FirewallBusinessModal,
        })
        const filterUsingWifi = optionUsingWifi.find(
          (item) =>
            item.value === String(result.Response.Data[0].ManagedWIFI.UsingWIFI)
        ).label;
        setSelectUsingWifi({
          value: result.Response.Data[0].ManagedWIFI.UsingWIFI,
          label: filterUsingWifi,
        });
        setSelectWifiBusinessModel({
          value: result.Response.Data[0].ManagedWIFI.WIFIBusinessModalValue,
          label: result.Response.Data[0].ManagedWIFI.WIFIBusinessModal,
        })
        const filterSecurityAuth = optionSecurityAuth.find(
          (item) =>
            item.value === String(result.Response.Data[0].ManagedWIFI.UserSecurityAuthentication)
        ).label;
        setSelectSecurityAuth({
          value: result.Response.Data[0].ManagedWIFI.UserSecurityAuthentication,
          label: filterSecurityAuth,
        })
        const filterUsingSDWAN = optionUsingSDWAN.find(
          (item) =>
            item.value ===
            String(result.Response.Data[0].SDWANMPLS.UsingSDWANorMPLS)
        ).label;
        setSelectUsingSDWAN({
          value: result.Response.Data[0].SDWANMPLS.UsingSDWANorMPLS,
          label: filterUsingSDWAN,
        });
        setSelectSdwanBusinessModel({
          value: result.Response.Data[0].SDWANMPLS.SDWANMPLSBusinessModalValue,
          label: result.Response.Data[0].SDWANMPLS.SDWANMPLSBusinessModal,
        })
        const filterSecurityCamera = optionSecurityCamera.find(
          (item) =>
            item.value ===
            String(result.Response.Data[0].VideoAnalytics.SecurityCameraUsage)
        ).label;
        setSelectSecurityCamera({
          value: result.Response.Data[0].VideoAnalytics.SecurityCameraUsage,
          label: filterSecurityCamera,
        });
        const filterAnalyticsSupport = optionAnalyticsSupport.find(
          (item) =>
            item.value ===
            String(result.Response.Data[0].VideoAnalytics.VideoAnalyticsPlatformSupport)
        ).label;
        setSelectAnalyticsSupport({
          value: result.Response.Data[0].VideoAnalytics.VideoAnalyticsPlatformSupport,
          label: filterAnalyticsSupport,
        })
        const filterPriSip = optionPriSip.find(
          (item) =>
            item.value === String(result.Response.Data[0].PRISIP.UsingPRISIP)
        ).label;
        setSelectPriSip({
          value: result.Response.Data[0].PRISIP.UsingPRISIP,
          label: filterPriSip,
        });
      } catch (error) {
        console.error("Error fetching ETR reasons:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCutomerInfraDetail();
  }, []);

  const handleChangeIndustryType = (selectIndustry) => {
    setSelectIndustryType(selectIndustry);
  };

  const handleChangeAccountTurnover = (selectAccount) => {
    setSelectAccountTurnover(selectAccount);
  };
  const handleChangeUsingFirewall = (selectFirewall) => {
    setSelectUsingFirewall(selectFirewall);
  };
  const handleChangeFirewallBusinessModel = (selectBusinessModel) => {
    setSelectFirewallBusinessModel(selectBusinessModel);
  };
  const handleChangeUsingWifi = (selectWifi) => {
    setSelectUsingWifi(selectWifi);
  };
  const handleChangeWifiBusinessModel = (selectWifiModel) => {
    setSelectWifiBusinessModel(selectWifiModel);
  };
  const handleChangeSecurityAuth = (selectAuth) => {
    setSelectSecurityAuth(selectAuth);
  };
  const handleChangeUsingSDWAN = (selectSDWAN) => {
    setSelectUsingSDWAN(selectSDWAN);
  };
  const handleChangeSdwanBusinessModel = (selectSdwan) => {
    setSelectSdwanBusinessModel(selectSdwan);
  };
  const handleChangeSecurityCamera = (selectSecurityCamera) => {
    setSelectSecurityCamera(selectSecurityCamera);
  };
  const handleChangeAnalyticsSupport = (selectAnySupport) => {
    setSelectAnalyticsSupport(selectAnySupport);
  };

  const handleChangePriSip = (selectPriSip) => {
    setSelectPriSip(selectPriSip);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const UpdateUrl = process.env.REACT_APP_API_URL;
      const UpdationData = {
        Action: "updateCustomerInfraDetails",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        userName: sessionStorage.getItem("userName"),
        password: sessionStorage.getItem("password"),
        CanId: sessionStorage.getItem("canId"),
        IndustryType: selectIndustryType.value ? selectIndustryType.value : "",
        AccTurnovervalue: `${selectAccountTurnover.value}`
          ? `${selectAccountTurnover.value}`
          : "",
        EmployeeCountatCANIDLocation: `${userData.serviceIdLoc}`
          ? `${userData.serviceIdLoc}`
          : "",
        NumberofLocation: `${userData.noOfLocation}`
          ? `${userData.noOfLocation}`
          : "",
        HOLocationName: userData.locationName ? userData.locationName : "",
        ISPNamePrimary: userData.ispNamePri ? userData.ispNamePri : "",
        ISPBandwidthPrimary: `${userData.bandwidthPri}`
          ? `${userData.bandwidthPri}`
          : "",
        ProductUsingfromPrimaryISP: userData.productFromPri
          ? userData.productFromPri
          : "",
        ISPNameSecondary: userData.ispNameSec ? userData.ispNameSec : "",
        ISPBandwidthSecondary: `${userData.bandwidthSec}`
          ? `${userData.bandwidthSec}`
          : "",
        ProductUsingfromSecondaryISP: userData.productFromSec
          ? userData.productFromSec
          : "",
        UsingFirewall: `${selectUsingFirewall.value}`
          ? `${selectUsingFirewall.value}`
          : "",
        IfYESwhoseFirewallaretheyusing: userData.firewallModel
          ? userData.firewallModel
          : "",
        FirewallBusinessModal: `${selectFirewallBusinessModel.value}`
          ? `${selectFirewallBusinessModel.value}`
          : "",
        IfFirewallUsingYesExpiryDate: userData.FirewallExpiryDate
          ? userData.FirewallExpiryDate
          : "",
        UsingWIFI: `${selectUsingWifi.value}` ? `${selectUsingWifi.value}` : "",
        IfYESwhoseWiFiaretheyusing: userData.wifiModel
          ? userData.wifiModel
          : "",
        NumberofAPifUsingYes: `${userData.numOfAp}`
          ? `${userData.numOfAp}`
          : "",
        WIFIBusinessModal: `${selectWifiBusinessModel.value}`
          ? `${selectWifiBusinessModel.value}`
          : "",
        UserSecurityAuthentication: `${selectSecurityAuth.value}`
          ? `${selectSecurityAuth.value}`
          : "",
        UsingSDWANorMPLS: `${selectUsingSDWAN.value}`
          ? `${selectUsingSDWAN.value}`
          : "",
        IfYESwhoseSDWANMPLSaretheyusing: userData.sdwanModel
          ? userData.sdwanModel
          : "",
        SDWANMPLSBusinessModal: `${selectSdwanBusinessModel.value}`
          ? `${selectSdwanBusinessModel.value}`
          : "",
        SecurityCameraUsage: `${selectSecurityCamera.value}`
          ? `${selectSecurityCamera.value}`
          : "",
        CompanyNameSecurityCamera: userData.companySecurityCamera
          ? userData.companySecurityCamera
          : "",
        VideoAnalyticsPlatformSupport: selectAnalyticsSupport.value
          ? selectAnalyticsSupport.value
          : "",
        UsingPRISIP: `${selectPriSip.value}` ? `${selectPriSip.value}` : "",
        PRISIPOperatorName: userData.priSipOperator
          ? userData.priSipOperator
          : "",
        NumberofChannel: `${userData.numOfChannel}`
          ? `${userData.numOfChannel}`
          : "",
        KDMName: userData.kdmName ? userData.kdmName : "",
        KDMDepartment: userData.kdmDepartment ? userData.kdmDepartment : "",
        KDMDesignation: userData.kdmDesignation ? userData.kdmDesignation : "",
        KDMContactNumber: userData.kdmNumber ? userData.kdmNumber : "",
        FfaUser: "test",
        KDMEmail: userData.kdmEmail ? userData.kdmEmail : "",
      };
      const response = await fetch(UpdateUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(UpdationData),
      });
      const data = await response.json();
      // console.log("API Response  create:", data);
      if (data.Response.StatusMessage === "Success") {
        toast.warning(data.Response.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setLoading(false);
      } else {
        toast.warning(data.Response.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setLoading(false);
      }
    } catch (error) {
      console.error("Error update CustomerInfra:", error);
    }
  };

  const handleIconClick = (formId) => {
    setActiveForm((prevActiveBox) =>
      prevActiveBox === formId ? null : formId
    );
  };

  const navigate = useNavigate();
  let canId = custmerInfo.CANId;
  const redirectCutomerInfraDetailPage = () => {
    navigate(`/customerInfra?CanId=${canId}`);
  };
  return (
    <>
      {/* ******************header********************** */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectCutomerInfraDetailPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">Customer Infra</span>
        </div>
      </div>
      {/* *********************Header end *************************** */}

      {loading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={loader} alt="loading...."></img>
          </div>
        </div>
      ) : (
        <div className="container-fluid" style={{ marginTop: "65px" }}>
          <div
            className="contact-toggle"
            onClick={() => handleIconClick("form1")}
          >
            <span className="toggle-text">Customer Details</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form1" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form1"
            >
              {/* *********Customer Details form******** */}
              <form className="srDetails-form p-3">
                <div className="srDetails-card">
                  <div className="row">
                    <div className="col-5 text-weight-color">Service Id</div>
                    <div className="col-1 ">:</div>
                    <div className="col-6">{custmerInfo.CANId}</div>
                  </div>
                  <div className="row">
                    <div className="col-5 text-weight-color">Customer Name</div>
                    <div className="col-1">:</div>
                    <div
                      className="col-6"
                      style={{ color: "rgb(148,101,170)" }}
                    >
                      {custmerInfo.CustomerName}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-5 text-weight-color">City</div>
                    <div className="col-1">:</div>
                    <div className="col-6">{custmerInfo.City}</div>
                  </div>

                  <div className="row">
                    <div className="col-5 text-weight-color">
                      Email Address{" "}
                    </div>
                    <div className="col-1">:</div>
                    <div className="col-6" style={{ wordWrap: "break-word" }}>
                      {custmerInfo.EmailAddress}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-5 text-weight-color">Product </div>
                    <div className="col-1">:</div>
                    <div className="col-6">{custmerInfo.Product}</div>
                  </div>

                  {/* <div className="card-data-row">
                        <span className="card-data-text">Product :</span>
                        <span className="card-data-value">
                          {custmerInfo.Product}
                        </span>
                      </div> */}
                  <div className="row">
                    <div className="col-5 text-weight-color">Segment </div>
                    <div className="col-1">:</div>
                    <div className="col-6">{custmerInfo.Segement}</div>
                  </div>
                </div>
              </form>
            </div>
          )}

          <div
            className="contact-toggle mt-3"
            onClick={() => handleIconClick("form2")}
          >
            <span className="toggle-text">Business Details</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form2" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form2"
            >
              {/* *********Business Details form******** */}
              <form className="Person-Address-form p-1">
                <div className="" style={{ position: "relative" }}>
                  <label className="select-search-label mt-1">
                    Industry Type*
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="IndustryType"
                    placeholder="Select Industry Type"
                    styles={style}
                    isSearchable={false}
                    value={selectIndustryType}
                    isDisabled={true}
                    onChange={handleChangeIndustryType}
                    options={industryTypes.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                  <i
                    className="fa-solid fa-lock"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "63%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                </div>

                <div className="">
                  <label className="select-search-label mt-1">
                    Account Turnover*
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="IndustryType"
                    placeholder="Select Option"
                    styles={style}
                    isSearchable={false}
                    value={selectAccountTurnover}
                    onChange={handleChangeAccountTurnover}
                    options={optionAccountTurnover.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="input-box form-floating">
                  <input
                    type="tel"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="noOfLocation"
                    name="noOfLocation"
                    // maxLength="10"
                    pattern="[0-9]{10}"
                    value={userData.noOfLocation}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (isDigit || allowedKeys.includes(e.key)) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    No. of Location*
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="tel"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="serviceIdLoc"
                    name="serviceIdLoc"
                    value={userData.serviceIdLoc}
                    onChange={handleChange}
                    // maxLength="10"
                    pattern="[0-9]{10}"
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (isDigit || allowedKeys.includes(e.key)) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                  />
                  <label
                    htmlFor="floatingInput"
                    className="mt-2"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Employee Count at Service ID Location*
                  </label>
                </div>

                <div className="input-box form-floating mb-2">
                  <input
                    type="text"
                    placeholder="Enter Mobile Number"
                    className=" form-control input-text form-control-sm mt-1"
                    id="locationName"
                    name="locationName"
                    value={userData.locationName}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    HO Location Name*
                  </label>
                </div>
              </form>
            </div>
          )}

          <div
            className="contact-toggle mt-3"
            onClick={() => handleIconClick("form3")}
          >
            <span className="toggle-text">Connectivity Details</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form3" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form3"
            >
              {/* *********Connectivity Details form******** */}
              <form className="Person-Address-form p-1">
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="ispNamePri"
                    name="ispNamePri"
                    value={userData.ispNamePri}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    ISP Name - Primary*
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="ispNameSec"
                    name="ispNameSec"
                    value={userData.ispNameSec}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    ISP Name - Secondary*
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="tel"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="bandwidthPri"
                    name="bandwidthPri"
                    // maxLength="10"
                    pattern="[0-9]{10}"
                    value={userData.bandwidthPri}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (isDigit || allowedKeys.includes(e.key)) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    ISP Bandwidth-Primary(In MBPS)*
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="tel"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="bandwidthSec"
                    name="bandwidthSec"
                    value={userData.bandwidthSec}
                    onChange={handleChange}
                    // maxLength="10"
                    pattern="[0-9]{10}"
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (isDigit || allowedKeys.includes(e.key)) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    ISP Bandwidth-Secondary(In MBPS)*
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="productFromPri"
                    name="productFromPri"
                    value={userData.productFromPri}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Product Using from-Primary ISP*
                  </label>
                </div>

                <div className="input-box form-floating mb-3">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="productFromSec"
                    name="productFromSec"
                    value={userData.productFromSec}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Product Using from-Secondary ISP*
                  </label>
                </div>
              </form>
            </div>
          )}

          <div
            className="contact-toggle mt-3"
            onClick={() => handleIconClick("form4")}
          >
            <span className="toggle-text">Network Security</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form4" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form4"
            >
              {/* *********Network Security form******** */}
              <form className="Person-Address-form p-1">
                <div className="">
                  <label className="select-search-label mt-1">
                    Using Firewall*
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="IndustryType"
                    placeholder="Select Option"
                    styles={style}
                    isSearchable={false}
                    value={selectUsingFirewall}
                    onChange={handleChangeUsingFirewall}
                    options={optionUsingFirewall.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="firewallModel"
                    name="firewallModel"
                    value={userData.firewallModel}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Current Firewall Make and Model?*
                  </label>
                </div>

                <div className="">
                  <label className="select-search-label mt-1">
                    Firewall-Business Model*
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="IndustryType"
                    placeholder="Select Option"
                    styles={style}
                    isSearchable={false}
                    value={selectFirewallBusinessModel}
                    onChange={handleChangeFirewallBusinessModel}
                    options={optionFirewallBusinessModel.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="input-box form-floating">
                  <input
                    type="date"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="FirewallExpiryDate"
                    name="FirewallExpiryDate"
                    value={userData.FirewallExpiryDate}
                    //   min={getCurrentDate()}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Firewall Expiry Date :
                  </label>
                </div>
              </form>
            </div>
          )}

          <div
            className="contact-toggle mt-3"
            onClick={() => handleIconClick("form5")}
          >
            <span className="toggle-text">Managed WI-FI</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form5" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form5"
            >
              {/* *********Managed WI-FI form******** */}
              <form className="Person-Address-form p-1">
                <div className="">
                  <label className="select-search-label mt-1">
                    Using WI-FI*
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="IndustryType"
                    placeholder="Select Option"
                    styles={style}
                    isSearchable={false}
                    value={selectUsingWifi}
                    onChange={handleChangeUsingWifi}
                    options={optionUsingWifi.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                {selectUsingWifi.label === "Yes" && (
                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="wifiModel"
                      name="wifiModel"
                      value={userData.wifiModel}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Current Wifi Make and Model?*
                    </label>
                  </div>
                )}

                {selectUsingWifi.label === "Yes" && (
                  <div className="input-box form-floating">
                    <input
                      type="tel"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="numOfAp"
                      name="numOfAp"
                      value={userData.numOfAp}
                      // maxLength="10"
                      pattern="[0-9]{10}"
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];
                        const isDigit = /\d/.test(e.key);
                        if (isDigit || allowedKeys.includes(e.key)) {
                          return true;
                        } else {
                          e.preventDefault();
                        }
                      }}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Number of AP*
                    </label>
                  </div>
                )}

                {selectUsingWifi.label === "Yes" && (
                  <div className="">
                    <label className="select-search-label mt-1">
                      Wi-Fi-Business Model*
                    </label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="IndustryType"
                      placeholder="Select Option"
                      styles={style}
                      isSearchable={false}
                      value={selectWifiBusinessModel}
                      onChange={handleChangeWifiBusinessModel}
                      options={optionWifiBusinessModel.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>
                )}

                {selectUsingWifi.label === "Yes" && (
                  <div className="mb-3">
                    <label className="select-search-label mt-1">
                      User Security Authentication*
                    </label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="IndustryType"
                      placeholder="Select Option"
                      styles={style}
                      isSearchable={false}
                      value={selectSecurityAuth}
                      onChange={handleChangeSecurityAuth}
                      options={optionSecurityAuth.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>
                )}
              </form>
            </div>
          )}

          <div
            className="contact-toggle mt-3"
            onClick={() => handleIconClick("form6")}
          >
            <span className="toggle-text">SDWAN/MPLS</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form6" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form6"
            >
              {/* *********SDWAN/MPLS form******** */}
              <form className="Person-Address-form p-1">
                <div className="mb-2">
                  <label className="select-search-label mt-1">
                    Using SDWAN/MPLS*
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="IndustryType"
                    placeholder="Select Option"
                    styles={style}
                    isSearchable={false}
                    value={selectUsingSDWAN}
                    onChange={handleChangeUsingSDWAN}
                    options={optionUsingSDWAN.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                {selectUsingSDWAN.label === "Yes" && (
                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="sdwanModel"
                      name="sdwanModel"
                      value={userData.sdwanModel}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInput" className="mt-2" style={{whiteSpace:"nowrap"}}>
                      Current SDWAN/MPLS Make and Model?*
                    </label>
                  </div>
                )}

                {selectUsingSDWAN.label === "Yes" && (
                  <div className="mb-3">
                    <label className="select-search-label mt-1">
                      SDWAN/MPLS-Business Model*
                    </label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="IndustryType"
                      placeholder="Select Option"
                      styles={style}
                      isSearchable={false}
                      value={selectSdwanBusinessModel}
                      onChange={handleChangeSdwanBusinessModel}
                      options={optionSdwanBusinessModel.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>
                )}
              </form>
            </div>
          )}

          <div
            className="contact-toggle mt-3"
            onClick={() => handleIconClick("form7")}
          >
            <span className="toggle-text">Video Analytics</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form7" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form7"
            >
              {/* *********Video Analytics form******** */}
              <form className="Person-Address-form p-1">
                <div className="">
                  <label className="select-search-label mt-1">
                    Security Camera Usage*
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="IndustryType"
                    placeholder="Select Option"
                    styles={style}
                    isSearchable={false}
                    value={selectSecurityCamera}
                    onChange={handleChangeSecurityCamera}
                    options={optionSecurityCamera.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                {selectSecurityCamera.label === "Yes" && (
                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="companySecurityCamera"
                      name="companySecurityCamera"
                      value={userData.companySecurityCamera}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Company Name-Security Camera
                    </label>
                  </div>
                )}

                {selectSecurityCamera.label === "Yes" && (
                  <div className="mb-2">
                    <label className="select-search-label mt-1">
                      Video Analytics-Platform Support
                    </label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="IndustryType"
                      placeholder="Select Option"
                      styles={style}
                      isSearchable={false}
                      value={selectAnalyticsSupport}
                      onChange={handleChangeAnalyticsSupport}
                      options={optionAnalyticsSupport.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>
                )}
              </form>
            </div>
          )}

          <div
            className="contact-toggle mt-3"
            onClick={() => handleIconClick("form8")}
          >
            <span className="toggle-text">PRI/SIP</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form8" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form8"
            >
              {/* *********PRI/SIP form******** */}
              <form className="Person-Address-form p-1">
                <div className="mb-2">
                  <label className="select-search-label mt-1">
                    Using PRI/SIP
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="IndustryType"
                    placeholder="Select Option"
                    styles={style}
                    isSearchable={false}
                    value={selectPriSip}
                    onChange={handleChangePriSip}
                    options={optionPriSip.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                {selectPriSip.label === "Yes" && (
                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="priSipOperator"
                      name="priSipOperator"
                      value={userData.priSipOperator}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      PRI/SIP-Operator Name
                    </label>
                  </div>
                )}
                {selectPriSip.label === "Yes" && (
                  <div className="input-box form-floating">
                    <input
                      type="tel"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="numOfChannel"
                      name="numOfChannel"
                      value={userData.numOfChannel}
                      onChange={handleChange}
                      // maxLength="10"
                      pattern="[0-9]{10}"
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];
                        const isDigit = /\d/.test(e.key);
                        if (isDigit || allowedKeys.includes(e.key)) {
                          return true;
                        } else {
                          e.preventDefault();
                        }
                      }}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Number of Channel(s)
                    </label>
                  </div>
                )}
              </form>
            </div>
          )}

          <div
            className="contact-toggle mt-3"
            onClick={() => handleIconClick("form9")}
          >
            <span className="toggle-text">KDM Details</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form9" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form9"
            >
              {/* *********KDM Details form******** */}
              <form className="Person-Address-form p-1">
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="kdmName"
                    name="kdmName"
                    value={userData.kdmName}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    KDM Name
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="kdmDepartment"
                    name="kdmDepartment"
                    value={userData.kdmDepartment}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    KDM Department
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="kdmDesignation"
                    name="kdmDesignation"
                    value={userData.kdmDesignation}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    KDM Designation
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="tel"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="kdmNumber"
                    name="kdmNumber"
                    value={userData.kdmNumber}
                    onChange={handleChange}
                    maxLength="10"
                    pattern="[0-9]{10}"
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (
                        (isDigit || allowedKeys.includes(e.key)) &&
                        (userData.kdmNumber.length < 10 ||
                          e.key === "Backspace")
                      ) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    KDM Contact Number
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="email"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="kdmEmail"
                    name="kdmEmail"
                    value={userData.kdmEmail}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    KDM Email
                  </label>
                </div>
              </form>
            </div>
          )}

          <div className=" text-center mt-5 mb-5">
            <button
              type="submit"
              className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
              onClick={handleSubmit}
            >
              Update
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomerInfraForm;
